import { render } from "./TimerComponent.vue?vue&type=template&id=03deb175&scoped=true&ts=true"
import script from "./TimerComponent.vue?vue&type=script&lang=ts"
export * from "./TimerComponent.vue?vue&type=script&lang=ts"

import "./TimerComponent.vue?vue&type=style&index=0&id=03deb175&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src277174800/src/yosrow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03deb175"]])

export default __exports__